import classcat from 'classcat';
import { twMerge } from 'tailwind-merge';
/**
 * Returns a concatenated string of the class names provided.
 * If an object is provided each of its keys with a value of true is concatenated.
 */
const buildClassName = (...rest) => {
    const className = twMerge(rest.map((item) => {
        if (typeof item === 'object') {
            if ('className' in item && 'selector' in item) {
                return item.toString();
            }
            return classcat(item);
        }
        return item;
    }));
    return className;
};
export { buildClassName };
//# sourceMappingURL=build-class-name.js.map